module.exports = __webpack_public_path__ + "img/SES_Slimliner_I_Overview.c894ea3b.jpg";